module.exports = __webpack_public_path__ + "img/dolar.8d378a72.svg";